import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import AdminNavbar from '../../../../components/CommonComponents/AdminNavbar';
import { useMyContext } from '../../../../components/Provider/CommonProvider';
import { findUploadName } from '../../../../components/CommonMethod/CommonMethods';
import AdminDeleteModal from '../../../../components/CommonComponents/AdminDeleteModal';
import Response_Processing from '../../../../layout/Others/Response_Processing';
import AdminTable from '../../../../components/CommonComponents/AdminTable';
import useTablePage from '../../../../components/CommonComponents/useTablePage';
const TranscodingFailed = ({ permissionData }) => {
    const BaseUrl = process.env.REACT_APP_Baseurl
    const listApi = `${BaseUrl}/admin/transcode-job/index`
    const retryApi = `${BaseUrl}/admin/retry-job`
    const { fetchRequest } = useMyContext()
    const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
    const [apiData, setApiData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState('')
    const [itemToRetry, setItemToRetry] = useState();
    const [modelClose, setModelClose] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithoutRefresh] = useState(false)

    const fetchData = async () => {
        setLoading(true)
        await fetchRequest({
            method: 'GET',
            url: `${listApi}`,
            params: { page, limit },
            data: {},
        })
            .then(response => {
                const result = response;
                const updatedList = result?.data?.map((item) => {
                    const UploadStatus = findUploadName(item?.uploaded_by);
                    return {
                        ...item, uploaded_by: UploadStatus,
                    }
                });
                setApiData(updatedList);
                setTotal(result?.pagination)
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
            })
    };

    const handleRetryApiAction = async () => {
        setShowOverlay(true);
        await fetchRequest({
            method: 'POST',
            url: `${retryApi}/${itemToRetry}`,
            params: {},
            data: {},
        })
            .then(response => {
                const result = response;
                if (result?.status) {
                    toast.success(result?.message);
                    setItemToRetry([])
                }
            })
            .catch(error => {
                toast.error(error?.response?.data?.message || error?.message)
            }).finally(() => {
                setShowOverlay(false)
                setWithoutRefresh(!withOutRefresh);
            })
    };

    const closeModal = () => {
        setModelClose(!closeModal);
        setItemToRetry()
    };

    const handleSelectRetry = (id) => {
        setItemToRetry(id)
        setModelClose(true)
    }

    const openModal = () => {
        setModelClose(true);
    };

    const handleRetryProceed = () => {
        handleRetryApiAction();
        closeModal();
    };

    const columns = [
        {
            dataField: "library_id",
            text: "Library Id",
            width: "10%",
        },
        {
            dataField: "job_logs",
            text: "Reason",
            width: "60%",
            formatter: (cell, row) =>
                <>
                    <h4 className='table-column-title  warningColor mb-2 avoid-overflow-ellipsis'>{row?.job_logs}</h4>
                    <div className='d-flex align-items-center flex-wrap gap-2 justify-content-start'>
                        <span className='dateText table-subheading theme-text-color'>{row?.upload_on}</span>
                        {permissionData?.userDetails?.id == row.user_id ? <span className='dateText table-subheading theme-text-color green-color-bg d-inline-block px-3 py-1 rounded-5'>{permissionData?.userDetails?.id == row.user_id ? "You" : ""}</span> : ""}
                    </div>
                </>,
            sort: true,
        },
        {
            dataField: "upload_type",
            text: "Source",
            width: "10%",
        },
        {
            dataField: "uploaded_by",
            text: "Upload by",
            width: "10%",
        },
        {
            dataField: "action",
            text: "Action",
            width: "10%",
            formatter: (cell, row) => {
                return <button className='alertColorBg rounded-4 px-4 py-2' onClick={() => handleSelectRetry(row?.job_id)}>Retry</button>
            }
        },
    ];

    const options = {
        pageStartIndex: 1,
        paginationSize: 3,
        sizePerPage: 10,
    };

    const reloadAction = () => {
        setWithoutRefresh(prev => !prev)
    }


    useEffect(() => {
        fetchData();
    }, [page, limit, withOutRefresh]);

    return (
        <div className='mb-4'>
            {modelClose && <AdminDeleteModal headingText={"Retry Confirmation"} modelClose={modelClose} deleteClose={closeModal} deleteAction={handleRetryProceed} buttonText="custom" message={"Are you sure you want to retry job"} actionText={"Proceed"} />}
            {showOverlay && <Response_Processing />}
            <AdminNavbar reLoading={loading} heading={"All Transcoding Failed Jobs"} totalDataLength={total?.totalItems} deleteCount={itemToRetry?.length} deleteMethod={openModal} reload reloadAction={reloadAction} />
            <div className='theme-bg-color p-3 rounded-3 mb-5'>
                <AdminTable data={apiData}
                    loading={loading}
                    options={options}
                    handlePageChange={handlePageChange}
                    page={page}
                    pagination={total}
                    handleSizePerPageChange={handleSizePerPageChange}
                    columns={columns}
                    limit={limit}
                    viewType={"list"}
                />
            </div >
        </div >
    )
}

const mapStateToProps = (state) => ({
    permissionData: state.userPermission.permissionData,
});
export default connect(mapStateToProps)(TranscodingFailed);
